import { PinnedMetadataProperties } from '#app/server/db.server.ts'
import { useNavigate } from '@remix-run/react'
import Button from '../buttons/button'
import Modal from '../modalsAndOverlays/modal'
import { TypographyHeading, TypographyParagraph } from '../typography'
import { useState } from 'react'

export const DeleteModal = ({
	open,
	onClose,
	entryToDelete,
}: {
	open: boolean
	onClose: ({
		success,
		message,
	}: {
		success: boolean
		message?: string
	}) => void
	entryToDelete: PinnedMetadataProperties | null
}) => {
	const navigate = useNavigate()
	const [loading, setLoading] = useState(false)

	const deleteEntry = async (
		metadataEntry: PinnedMetadataProperties | null,
	) => {
		if (!metadataEntry) return
		setLoading(true)
		try {
			const signResponse = await fetch('/deleteMetadataAPI', {
				method: 'POST',
				headers: {
					'Content-Type': 'application/json',
				},
				body: JSON.stringify({ deleteData: metadataEntry }),
			})
			const jsonResponse = (await signResponse.json()) as {
				success: boolean
				data: any
			}
			if (jsonResponse.success === true) {
				setLoading(false)
				onClose({
					success: true,
					message: 'The entry was successfully deleted.',
				})
				setLoading(false)
			} else {
				onClose({
					success: false,
					message:
						'There was an error when attempting to delete the entry. Please try again.',
				})
				setLoading(false)
			}
		} catch (e) {
			onClose({
				success: false,
				message:
					'There was an unexpected error when attempting to delete the entry. Please try again.',
			})
			setLoading(false)
		}
	}

	return (
		<Modal
			size={'small'}
			body={
				<div className="flex flex-col items-center gap-y-4">
					<TypographyHeading
						size="large"
						isBold={true}
						additionalClasses="text-textPrimaryLight dark:text-textPrimaryDark"
					>
						Confirm Deletion
					</TypographyHeading>
					<TypographyParagraph
						size="medium"
						additionalClasses="text-textPrimaryLight dark:text-textPrimaryDark"
					>
						Are you sure you want to delete this draft? This action cannot be
						undone and will permanently remove the draft from your attestations
						records. Please confirm if you wish to proceed.
					</TypographyParagraph>
					<Button
						variant="primary"
						additionalClasses="w-full"
						disabled={loading}
						onClick={() => {
							deleteEntry(entryToDelete)
						}}
					>
						{loading ? 'Loading...' : 'Confirm'}
					</Button>
					<Button
						variant="secondary"
						additionalClasses="w-full mt-2"
						disabled={loading}
						onClick={() => onClose({ success: true })}
					>
						Close
					</Button>
				</div>
			}
			isOpen={open}
			onClose={() => onClose({ success: true })}
		/>
	)
}
